import { render, staticRenderFns } from "./VoucherUsageHistory.vue?vue&type=template&id=b6890ab0"
import script from "./VoucherUsageHistory.vue?vue&type=script&lang=js"
export * from "./VoucherUsageHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports